import { render, staticRenderFns } from "./PropertyIndex.vue?vue&type=template&id=615c785b&scoped=true"
import script from "./PropertyIndex.vue?vue&type=script&lang=js"
export * from "./PropertyIndex.vue?vue&type=script&lang=js"
import style0 from "./PropertyIndex.vue?vue&type=style&index=0&id=615c785b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c785b",
  null
  
)

export default component.exports